import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"

export default function Facet({ facet }) {
    // const { toggleProductFilter } = useFacet(facet)
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)
    return (
      <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`} aria-expanded={!!active}>
        <span
          class="ns-anchor ns-relative ns-w-100 ns-border-box ns-p-4 nosto-facet-title"
          data-nosto-element="facet"
          onClick={toggleActive}
          aria-controls={`${facet.id}-sub-menu`}
          aria-label={`${active ? "Collapse" : "Expand"} ${facet.name}`}
        >
          <span class="ns-color-black ns-facet-name">{facet.name}</span>
          <svg aria-label="Plus icon" class="icon icon--plus" width="24" height="24" viewBox="0 0 24 24">
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeWidth="1.5"
              d="M12 6v12M6 12h12"
            />
          </svg>
        </span>
        <div
          class="ns-sidebar-submenu ns-d-none ns-p-4"
          id={`${facet.id}-sub-menu`}
          style={{ display: active ? "block" : "none" }}
        >
          <ul
            class="ns-list-unstyled ns-p-0 ns-m-0 filter-bubbles original-style"
            role="menu"
          >
            {facet.data?.map(value => (
              <li
                key={value.value}
                class="filter-bubble ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                data-nosto-element="facet-setting"
                role="menuitem"
              >
                <Checkbox
                  value={value.value}
                  selected={value.selected}
                  onChange={e => {
                    e.preventDefault()
                    toggleProductFilter(facet.field, value.value, !value.selected)
                  }}
                />
              </li>
            ))}
          </ul>
        </div>
      </li>
    )
  }
